export default "__VITE_ASSET__BmcD9TDk__"